import React from 'react';
import { IonAlert, IonButton, IonIcon } from '@ionic/react';
import { checkmarkCircle } from 'ionicons/icons';
import Modal from '../modal';
import { NormalText, Spacer, StrongText, Title } from '../common';
import { withTranslation } from '../../lib/translate';
import { getConfig } from '../../appConfig';

const SuccessModal = ({ __, isOpen, title, message, onDismiss }) => {
	if (getConfig().flags.hasRegularAlerts) {
		return (
			<IonAlert
				isOpen={isOpen}
				onDidDismiss={onDismiss}
				header={title}
				message={message}
				buttons={[
					{
						text: __('OK'),
						role: 'cancel',
						cssClass: 'primary',
					},
				]}
			/>
		);
	}
	return (
		<Modal onDidDismiss={onDismiss} isOpen={isOpen} className="modal-type-alert">
			<StrongText className="block">{__('Success!')}</StrongText>
			<Spacer size={5} />
			<div style={{ display: 'grid', justifyItems: 'center', textAlign: 'center' }}>
				<IonIcon style={{ height: '48px', width: '48px' }} color="success" icon={checkmarkCircle} />
				<Title className="block">{title}</Title>
				<NormalText className="block">{message}</NormalText>
			</div>
			<Spacer size={5} />
			<div className="alert-button-group">
				<IonButton color="primary" expand="block" onClick={onDismiss} className="submit-button button-uppercase">
					{__('Nice!')}
				</IonButton>
			</div>
		</Modal>
	);
};

export default withTranslation(SuccessModal);
